<template>
  <q-page :class="classes">
    <div class="container-outer">
      <div class="container-inner">
        <div class="content">
          <title-section v-if="title" :icon="icon" :label="title" />
          <slot></slot>
          <footer-section />
        </div>
      </div>
    </div>
  </q-page>
</template>

<script>
import FooterSection from "../sections/FooterSection.vue";
import TitleSection from "../sections/TitleSection.vue";
import { model, Device } from "@/model/Model";

export default {
  components: {
    TitleSection,
    FooterSection,
  },
  props: {
    icon: String,
    title: String,
  },

  computed: {
    mobile() {
      return model.device == Device.SMALL;
    },

    classes() {
      return {
        "camoodoo-page": true,
        "camoodoo-page--mobile": this.mobile,
      };
    },
  },
};
</script>

<style scoped>
.container-outer {
  display: flex;
  justify-content: center;
}

.container-inner {
  display: flex;
  flex-direction: column;
  max-width: 650pt;
  min-width: 300px;
  width: 80vw;
}

.camoodoo-page--mobile .container-inner {
  max-width: 100vw;
  min-width: 100vw;
  width: 100vw;
}

.content {
  border-radius: 10px;
  box-shadow: 0 0 40px #0000006e;
  padding: 0px;
  flex: 1 1 auto;
  background: #232323;
  overflow: hidden;
  margin: 30pt 5pt;
  --content-margin: 20pt;
  --section-padding: 60pt;
}

.camoodoo-page--mobile .content {
  border-radius: 0px;
  box-shadow: 0 0 40px #0000006e;
  padding: 0px;
  flex: 1 1 auto;
  background: #232323;
  overflow: hidden;
  margin: 0pt;
  --content-margin: 20pt;
  --section-padding: 30pt;
  font-size: 12pt;
}
</style>
